<template>
  <div>
    <v-system-bar :color="currentPath === '/' ? 'rgb(239, 237, 237)' : 'white'" :height="isMobile ? '65' : '120'" window
      class="d-flex justify-center">

      <v-btn @click="toMain()" icon class="no-background-hover d-flex justify-center pl-0"  elevation="0"
        v-if="getUserID !== '' && currentPath === '/myInfo'" absolute left :ripple="false">
        <img src="../assets/btn_pre_n.png" class="btn_pre_img">
      </v-btn>
      <v-btn @click="toUserInfo" class="d-flex justify-center no-background-hover bgcolor pl-0 pr-7" :class="isMobile ? 'pl-0' : 'pl-10'" elevation="0"
        v-if="getUserID !== '' && currentPath !== '/myInfo'" absolute left :ripple="false">
        <img class="bgcolor d-flex justify-start" src="../assets/btn_profile_n.png"
          style="max-width: 5vw; max-height: 5vw;">
      </v-btn>

      <v-btn text class="text-h5 no-background-hover text-center" @click="toMain()" :ripple="false" elevation="0">
        <img src="../assets/u2lablogo.png" style="width: 25vw;">
      </v-btn>

      <v-btn v-if="getUserID !== ''" icon class="no-background-hover" :class="isMobile ? '' : 'pl-0 pr-16'" absolute right @click="toPushList()" elevation="0"
        :ripple="false">
        <v-badge color="red" :content="getNewNoticeCNT" :value="getNewNoticeCNT" offset-x="10" overlap>
          <img class="d-flex justify-start" src="../assets/btn_alarm_n.png" style="max-width: 5vw; max-height: 5vw;">
          <!-- <v-icon :x-large="$vuetify.breakpoint.smAndUp" color="black">mdi-bell-outline</v-icon> -->
        </v-badge>
      </v-btn>

    </v-system-bar>
  </div>
</template>
<style scoped>
@import '@/assets/css/commonCSS.css';

.bgcolor {
  background-color: rgb(239, 237, 237) !important;
}
</style>
<script>
import * as commonFunction from './commonFunction';
export default {
  created() {
    this.setCurrentPath()
  },

  data: () => ({
    currentPath: window.location.pathname,
    newPush: 0,
    isMyInfo: false,
    alarm1: '../assets/btn_alarm_n.png',
    alarm2: '../assets/btn_alarm_s.png',
    idx: 0
  }),

  computed: {
    getUserID: function () {
      return this.$store.getters['userStore/getUserID']
    },

    getUserInfo: function () {
      return this.$store.getters['userStore/getUserInfo']
    },

    getNewNoticeCNT: function () {
      return this.$store.getters['pushStore/getCNT']
    },

    getIsMyInfo: function () {
      return this.$store.getters['menuStore/getIsMyInfo']
    },
    isMobile() {
      return commonFunction.isMobile()
    }
  },

  watch: {
    '$route'(to, from) {
      if (to.path === '/') {
        this.currentPath = '/'
      } else if (to.path === '/myInfo') {
        this.currentPath = '/myInfo'
      }
    }
  },

  methods: {
    toMain() {
      this.currentPath = '/'
      this.idx += 1
      this.$router.push('/')
    },

    toUserInfo() {
      this.currentPath = '/myInfo'
      this.$router.push('/myInfo')
    },

    toPushList() {
      this.$router.push('/pushList')
    },

    setCurrentPath() {
      this.$store.commit('mutationCurrentPath', this.currentPath)
    },

    showMyInfo() {
      this.$store.commit('menuStore/showMy')
    }

  }
}
</script>
